
<template>
  <router-view v-slot="{ Component, route }">
    <keep-alive :max="20">
      <component :is="Component" :key="viewCacheKey(route)" />
    </keep-alive>
  </router-view>
</template>

<script>
import { computed, inject } from 'vue';

export default {
  name: 'tmRouterView',
  setup() {
    const $store = inject('$store');
    const viewCacheVersionMap = computed(() => $store?.state?.viewCacheVersionMap || {});

    const viewCacheKey = (route) => {
      const fullPath = route?.fullPath || '';
      const version = viewCacheVersionMap.value?.[fullPath] || 0;
      return `${fullPath}::${version}`;
    };

    return { viewCacheKey };
  },
};
</script>

<style lang="less" scoped>
</style>
